document.addEventListener("DOMContentLoaded", () => {
  window.AOS.init();
});